  import React from 'react'
  
  const Services = () => {
    return (
      <div className="Services" id="services">
        <div className="mainTitle">
          <div className="lines">
            <div className="line"></div>
            <div className="line"></div>
            <div className="title">
              <h2>خدمتنا</h2>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="mainContent">
            <div className="boxs">
              <div className="box">
                <div className="hexagon-clip">
                  <img
                    src="https://res.cloudinary.com/defcamc5x/image/upload/v1761305146/bt7gzjv4cmpoln2gexcp.png"
                    alt=""
                  />
                </div>
                <p>القضايا المدنية</p>
              </div>
              <div className="box">
                <div className="hexagon-clip">
                  <img
                    src="https://res.cloudinary.com/defcamc5x/image/upload/v1761306598/qmbzmdjavldo4cjcgfli.png"
                    alt=""
                  />
                </div>
                <p>القضايا الجنائية</p>
              </div>
              <div className="box">
                <div className="hexagon-clip">
                  <img
                    src="https://res.cloudinary.com/defcamc5x/image/upload/v1761307145/t4kdduac0g8zuqrocjcc.png"
                    alt=""
                  />
                </div>
                <p>القضايا التجارية</p>
              </div>
              <div className="box">
                <div className="hexagon-clip">
                  <img
                    src="https://res.cloudinary.com/defcamc5x/image/upload/v1761308192/swwd2cgtwhbazihugq92.png"
                    alt=""
                  />
                </div>
                <p>تأسيس الشركات</p>
              </div>
              <div className="box">
                <div className="hexagon-clip">
                  <img
                    src="https://res.cloudinary.com/defcamc5x/image/upload/v1761308486/egbwytxzqvx3jknxhzzh.png"
                    alt=""
                  />
                </div>
                <p>صياغة العقود</p>
              </div>
              <div className="box">
                <div className="hexagon-clip">
                  <img
                    src="https://res.cloudinary.com/defcamc5x/image/upload/v1761311103/nsepmlpbkom3bcln4nuq.png"
                    alt=""
                  />
                </div>
                <p>قضايا الأحوال الشخصية</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default Services